import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FormAreasService {
  getFormFields() {
    return {
      localAlteracao: [
        'Área tecnológica (criação de uma nova área)',
        'Área tecnológica (alteração de uma área proposta)',
      ],

      camposAreaTecnologica: [
        {
          label: 'Nome',
          fields: {
            proposta: 'propostaNomeAreaTecnologica',
            justificativa: 'justificativaNomeAreaTecnologica',
          },
          checkbox: 'nomeArea',
        },
        {
          label: 'Descritor',
          fields: {
            proposta: 'propostaDescritorAreaTecnologica',
            justificativa: 'justificativaDescritorAreaTecnologica',
          },
          checkbox: 'descritorArea',
        },

      ],

      textoTermo: 'Autorizo o Ministério da Educação e a equipe responsável pela atualização dos Catálogos Nacionais de Cursos a entrarem em contato comigo pelo endereço de e-mail informado neste formulário para tirar dúvidas e complementar informações.'
    };
  }
}
